import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, notification } from 'antd';
import { Button } from '@seaters/ui';
import { AttendeeInfoStep, useAttendeeInfoStore } from '@seaters/ui-shared';
import {
  TicketsUrl,
  useReexportGuestVoucher,
  useUpdateGuestAttendeeInfo,
} from '@seaters/data-access';
import {
  AttendeesInfoFormValidator,
  GuestWaitingList,
  WaitingListAcceptFormat,
} from '@seaters/constants';

interface AdjustAttendeeListProps {
  waitingList: GuestWaitingList;
  setWlRefetching: (v: boolean) => void;
  setLoading: (v: TicketsUrl) => void;
}

const AdjustAttendeeList: React.FC<AdjustAttendeeListProps> = ({
  waitingList,
  setWlRefetching,
  setLoading,
}) => {
  const { t } = useTranslation();

  const searchParams = new URLSearchParams(window.location.search);

  const code = searchParams.get('code') ?? '';

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { attendees } = waitingList.position.attendeesInfo;

  const { mutate: updateGuestAttendeesInfo } = useUpdateGuestAttendeeInfo(
    waitingList.waitingListId,
    { code }
  );

  const { mutateAsync: reExportVoucher, isPending: isLoadingReexport } =
    useReexportGuestVoucher(waitingList.waitingListId, { code });

  const { setAttendees, setCurrentAttendee } = useAttendeeInfoStore();

  const handleOpenModal = () => {
    setModalOpen(true);

    if (attendees.length) {
      setAttendees(attendees);
      setCurrentAttendee(attendees.length);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleAttendeeForm = (attendeeValues: AttendeesInfoFormValidator[]) => {
    updateGuestAttendeesInfo(
      { attendeeInfo: { attendees: attendeeValues } },
      {
        onSuccess: () => {
          handleCloseModal();
          notification.success({
            message: t('attendee_info_update_success'),
          });
          reExportVoucher({
            format: WaitingListAcceptFormat.MULTIPAGE_PDF_FILE,
          });
          setWlRefetching(true);
          setLoading('exportedVoucherUrl');
        },
      }
    );
  };

  return (
    <div>
      <Button type="link" onClick={handleOpenModal}>
        {t('adjust_attendee_list_button')}
      </Button>
      <Modal
        open={modalOpen}
        style={{ maxWidth: 1284 }}
        title={t('checkout_title')}
        closeIcon={null}
        footer={false}
        width={'100%'}
        maskClosable
        onCancel={handleCloseModal}
      >
        <AttendeeInfoStep
          waitingList={waitingList}
          handleAttendeeForm={handleAttendeeForm}
          submitForm={t('button_text_submit').toString()}
        />
      </Modal>
    </div>
  );
};

export default AdjustAttendeeList;
